import { render, staticRenderFns } from "./Bewerbung.vue?vue&type=template&id=bfff44cc"
import script from "./Bewerbung.vue?vue&type=script&lang=js"
export * from "./Bewerbung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports